<template>
  <q-page>
    <main-header
      class="col-12"
      :img-src="`/img/services/${page}.jpg`"
      :title="content.title"
    />
    <div class="container row justify-center">
      <div class="service-page-content col-12 col-md-8">
        <h4 class="service-title text-center text-bold">
          {{ content.page_title }}
        </h4>
        <div
          v-for="row in content.content_top"
          :key="row"
          class="service-text text-center"
        >
          <p>{{ row }}</p>
        </div>
        <div class="row service-icons-top">
          <div
            v-for="(value, key) in content.types"
            :key="key"
            class="col-12 col-sm-3 column items-center service-icon-top"
          >
            <q-icon
              :name="key"
              size="48px"
              class="text-primary"
            />
            <span class="service-icon-caption text-bold text-center">
              {{ value }}
            </span>
          </div>
        </div>
        <div
          v-for="row in content.content_bottom"
          :key="row"
          class="service-text text-center"
        >
          <p>{{ row }}</p>
        </div>
      </div>
    </div>
    <div class="row justify-center content-bottom">
      <div class="col-md-6 col-sm-10 q-mx-md">
        <h4 class="service-title text-center text-bold">
          {{ content.reasons.title }}
        </h4>
        <p class="service-text text-center">{{ content.reasons.text }}</p>
      </div>
      <div class="col-md-6 col-sm-6 q-mx-md">
        <div class="row">
          <div
            v-for="(value, key) in content.reasons.columns"
            :key="key"
            class="col-md-6"
          >
            <div class="service-icons-bottom row no-wrap">
              <q-icon
                :name="key"
                size="34px"
                class="service-icon-bottom text-primary"
              />
              <div class="column col-md-9">
                <h4 class="service-icon-title text-bold">{{ value.title }}</h4>
                <span>{{ value.text }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import MainHeader from 'components/MainHeader';

export default {
  name: 'ServicePage',
  components: {
    MainHeader,
  },
  preFetch({ currentRoute, redirect }) {
    if (['airplane', 'helicopter'].some((el) => currentRoute.name.includes(el))) {
      return redirect({ name: 'index' });
    }

    return null;
  },
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  computed: {
    content() {
      return this.$t(`pages.services.${this.page}`);
    },
  },
};
</script>

<style scoped lang="scss">
.service {
  &-page-content {
    padding: 72px 16px 50px;
  }
  &-title {
    margin: 0 0 15px;
    @media (max-width: 599px) {
      font-size: 24px;
    }
  }
  &-text {
    font-size: 16px;
    p {
      margin-bottom: 6px;
      @media (max-width: 599px) {
        margin-bottom: 0;
      }
    }
  }
  &-icons-top {
    margin: 55px 0 20px;
  }
  &-icon-caption {
    margin-top: 32px;
    font-size: 18px;
  }
  &-icons-bottom {
    margin-top: 40px;
  }
  &-icon-top {
    margin-bottom: 25px;
  }
  &-icon-bottom {
    align-items: flex-start !important;
    margin-right: 15px;
  }
  &-icon-title {
    font-size: 24px;
    margin: 7px 0 10px;
  }
}

.content-bottom {
  background-color: #f7f7f7;
  padding: 64px 0;
}
.icon-another {
  filter: blur(2px);
}
</style>
